import { Inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CoreExternalService } from '../../common-api/rt-common-api/system-parameter/api/coreExternal.service';
import {
  CacheService,
  MEMORY_CACHE_SERVICE,
} from '../../common/services/cache.service';

/**
 * 整併案專用控管
 * @export
 * @class CoreFeatureFlagService
 */
@Injectable({
  providedIn: 'root',
})
export class CoreFeatureFlagService {
  private readonly options: CoreFeatureFlagOptions = {
    useCache: true,
    cacheKey: 'CoreFeatureFlag',
  };

  constructor(
    private api: CoreExternalService,
    @Inject(MEMORY_CACHE_SERVICE) private cache: CacheService
  ) {}

  /**
   * 非同步取得啟用狀態
   */
  public async getCoreFeatureFlag(): Promise<boolean> {
    const { useCache, cacheKey } = this.options;

    if (useCache) {
      const cached = this.cache.get<boolean>(cacheKey);
      if (cached !== undefined) {
        return cached;
      }
    }

    const isEnabled = await firstValueFrom(
      this.api.externalCoreFeatureFlagIsEnabledGet()
    );

    if (useCache) {
      this.cache.add(cacheKey, isEnabled);
    }

    return isEnabled;
  }
}

interface CoreFeatureFlagOptions {
  useCache: boolean;
  cacheKey: string;
}
